import { useEffect, useState } from "react";
import { IOrder, IProduct, IUser } from "../shared/types";
import { getUsers } from "../api/usersService";
import { getProducts } from "../api/productsService";
import { getOrders } from "../api/ordersService";
import { maps_data, companies_data, applicants_data } from "../mock/mock_data";

export type ListType = "User" | "Product" | "Order" | "Events" | "Maps" | "Companies" | "Applicants";
export type DataType = IUser[] | IProduct[] | IOrder[];

// Custom hook that accepts type and returns data from backend API
export const useData = (type: ListType) => {
  const [data, setData] = useState<DataType>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (type === "User") {
          const users = await getUsers();
          setData(users || []);
        } else if (type === "Product") {
          const products = await getProducts();
          setData(products || []);
        } else if (type === "Order") {
          const orders = await getOrders();
          setData(orders || []);
        } else if (type === "Events") {
          setData([]);
        } else if (type === "Maps") {
          setData(maps_data);
        } else if (type === "Companies") {
          setData(companies_data);
        } else if (type === "Applicants") {
          setData(applicants_data);
        }
      } catch (error) {
        console.error(`Error fetching ${type} data:`, error);
        setData([]);
      }
    };

    fetchData();
  }, [type]);

  return data;
};
